import "./DownCurve.style.scss";
import { ReactComponent as Curve } from "./../../images/svg/edgeCurv-Down.svg";

const DownCurve = (props) => <Curve className={`down-curv ${props?.curvStyle}`} />;

export default DownCurve;
